<template>
  <VBtn v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <slot
      v-for="slot in Object.keys($slots).filter(name => name != 'default')"
      :name="slot"
      :slot="slot"
    ></slot>

    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </VBtn>
</template>
<script>
import { $t } from '@/plugins/locales';

const isTextNode = node => node?.nodeName == '#text';

const textNodeTranslator = textNode => {
  if (!isTextNode(textNode)) return;
  const text = $t(textNode?.textContent?.trim());
  if (textNode?.textContent && text && textNode?.textContent?.trim() != text)
    textNode.textContent = text;
};

const findTextNode = (node, arr = []) => {
  if (isTextNode(node)) arr.push(node);
  else if (node.hasChildNodes())
    node.childNodes.forEach(child => findTextNode(child, arr));
  return arr;
};

const defaultSlotObserver = new MutationObserver(mutationsList => {
  for (var mutation of mutationsList) {
    textNodeTranslator(mutation.target);
  }
});

export default {
  data() {
    return {
      ObserverDisconnectTarget: [],
    };
  },
  mounted() {
    this.ObserverDisconnectTarget = findTextNode(this.$el);
    this.ObserverDisconnectTarget.forEach(node => {
      textNodeTranslator(node);
      defaultSlotObserver.observe(node, {
        characterData: true,
      });
    });
  },
  destroyed() {
    this.ObserverDisconnectTarget.forEach(node => {
      defaultSlotObserver.disconnect(node);
    });
  },
};
</script>
